import { Route, Routes } from "react-router-dom";
import { createContext } from "react";
import { PromotionListing } from "../../modules/promotion/component/PromotionListing";

const PromotionContext = createContext();

const PromotionWrapper = () => {
  const value = {};

  return (
    <PromotionContext.Provider value={value}>
      <Routes>
        <Route path="" element={<PromotionListing />} />
      </Routes>
    </PromotionContext.Provider>
  );
};

export { PromotionWrapper };
